export default "__VITE_ASSET__BZVFjIrm__"